// Keeps submitted follow-ups visible while the backend waits to process them.
import { type ReactNode } from 'react';

import { type QueuedUserMessage } from '@apps/web/features/phoebe_chat_v3/model/projection';
import { ReferenceText } from '@apps/web/features/phoebe_chat_v3/ui/primitives/reference_badge';

export function QueuedMessages({
    messages,
}: Readonly<{
    readonly messages: ReadonlyArray<QueuedUserMessage>;
}>): ReactNode {
    if (messages.length === 0) {
        return null;
    }

    return (
        <section aria-label="Messages queued for Phoebe" className="mb-2">
            <ol className="m-0 max-h-40 list-none space-y-1 overflow-y-auto p-0 pr-1">
                {messages.map((message) => (
                    <li
                        key={message.occurrenceId}
                        className="bg-muted/70 flex min-w-0 items-start rounded-lg py-2 pr-3 pl-3"
                    >
                        <p className="text-v3-chat min-w-0 flex-1 break-words whitespace-pre-wrap">
                            <ReferenceText
                                text={message.text}
                                attachedShifts={true}
                            />
                        </p>
                    </li>
                ))}
            </ol>
        </section>
    );
}
